import React, {Component} from 'react';
import {NavLink} from "react-router-dom";
import ExpandableSection from "@amzn/awsui-components-react-v3/polaris/expandable-section";
import Box from "@amzn/awsui-components-react-v3/polaris/box";
import Link from "@amzn/awsui-components-react-v3/polaris/link";
import './style.scss';
import {NAVIGATION_PANE, URLS} from "../../util/ConfigConstants";
import {AppConfig, AppConfigMapKey} from "../config/AppConfig";
import { credentialStorage } from '@awsscm/argo-core/argo/utils/CredentialStorage';
import { TextContent } from '@amzn/awsui-components-react-v3';

interface NavigationContentProps {
  navItemsArray: () => SectionProps[];
}

interface SectionProps {
  sectionTitle: string,
  items: NavItemProps[] 
}

interface NavItemProps {
  enable: boolean; 
  isExternalLink: boolean; 
  link: string; 
  displayText: string;
}

const navItems = () : SectionProps[] => {
  var navItems: SectionProps[] = [{
  sectionTitle: NAVIGATION_PANE.SECTION_TITLE,
  items: [
    {
      link: URLS.PAGES.TRACK_SHIPMENTS,
      displayText: NAVIGATION_PANE.TRACK_SHIPMENTS,
      enable: true,
      isExternalLink: false
    },
    {
      link: URLS.PAGES.UPLOAD_ASN,
      displayText: NAVIGATION_PANE.UPLOAD_ASN,
      enable: AppConfig.getConfigValue(AppConfigMapKey.ENABLE_UPLOAD_ASN),
      isExternalLink: false
    },
    {
      link: URLS.PAGES.CREATE_BOOKING,
      displayText: NAVIGATION_PANE.CREATE_BOOKING,
      enable: AppConfig.getConfigValue(AppConfigMapKey.ENABLE_CREATE_BOOKING),
      isExternalLink: false
    },
    {
      link: URLS.PAGES.DMS_SEARCH,
      displayText: NAVIGATION_PANE.DMS,
      enable: AppConfig.getConfigValue(AppConfigMapKey.ENABLE_DMS) && !credentialStorage.isExternalUser(),
      isExternalLink: false
    },
    {
      link: URLS.PAGES.ASSET_TDD_HISTORY_URL,
      displayText: NAVIGATION_PANE.ASSET_TDD_HISTORY,
      enable: !credentialStorage.isExternalUser(),
      isExternalLink: true
    },
    {
      link: URLS.PAGES.SHIPPING_CONFIGURATION_URL,
      displayText: NAVIGATION_PANE.SHIPPING_CONFIGURATIONS,
      enable: AppConfig.getConfigValue(AppConfigMapKey.ENABLE_SHIPPING_CONFIGURATIONS_IN_NAV_BAR) && !credentialStorage.isExternalUser(),
      isExternalLink: false
    },
    {
      link: URLS.PAGES.DOWNLOADS,
      displayText: NAVIGATION_PANE.DOWNLOADS,
      enable: AppConfig.getConfigValue(AppConfigMapKey.ENABLE_SHIPMENTS_DOWNLOAD_PAGE_IN_NAV_BAR) && !credentialStorage.isExternalUser(),
      isExternalLink: false
    },
    {
      link: URLS.PAGES.BULK_ACTIONS,
      displayText: NAVIGATION_PANE.BULK_ACTIONS,
      enable: AppConfig.getConfigValue(AppConfigMapKey.ENABLE_BULK_ACTIONS_IN_NAV_BAR) && !credentialStorage.isExternalUser(),
      isExternalLink: false
    }
  ]
  }]
  return navItems;
};

const lmdpNavItems = () : SectionProps[] => {
  var navItems: SectionProps[] = [{
  sectionTitle: NAVIGATION_PANE.LMDP,
  items: [  
    {
      link: URLS.PAGES.PLANNED_DELIVERIES,
      displayText: NAVIGATION_PANE.PLANNED_DELIVERIES,
      enable: AppConfig.getConfigValue(AppConfigMapKey.ENABLE_LMDP) && !credentialStorage.isExternalUser(),
      isExternalLink: false
    },
    {
      link: URLS.PAGES.THREE_WEEK_CABLING_FORECAST,
      displayText: NAVIGATION_PANE.CABLING_FORECAST,
      enable: AppConfig.getConfigValue(AppConfigMapKey.ENABLE_LMDP) && !credentialStorage.isExternalUser(),
      isExternalLink: false
    },
    {
      link: URLS.PAGES.DELIVERY_FORECAST,
      displayText: NAVIGATION_PANE.DELIVERY_FORECAST,
      enable: AppConfig.getConfigValue(AppConfigMapKey.ENABLE_LMDP) && !credentialStorage.isExternalUser(),
      isExternalLink: false
    },
    {
      link: URLS.PAGES.THROUGHPUT_BLOCKED_DELIVERY,
      displayText: NAVIGATION_PANE.BLOCKED_DELIVERIES,
      enable: AppConfig.getConfigValue(AppConfigMapKey.ENABLE_LMDP) && !credentialStorage.isExternalUser(),
      isExternalLink: true
    },
    {
      link: URLS.PAGES.LAST_MILE_HUB_VIEW,
      displayText: NAVIGATION_PANE.LAST_MILE_HUB_VIEW,
      enable: AppConfig.getConfigValue(AppConfigMapKey.ENABLE_LAST_MILE_HUB_VIEW_IN_NAV_BAR) && !credentialStorage.isExternalUser(),
      isExternalLink: false
    }
  ]
  }]
  return navItems;
};

export const NavigationContent = ({navItemsArray} : NavigationContentProps) => {
  const itemsArray = navItemsArray();
  let nav: any = [];
  itemsArray?.map((section) => {
    const sectionItems = section.items.map((item: NavItemProps) => {
      if (typeof item.enable === 'undefined' || item.enable) {
        return getNavigationItemContent(item.isExternalLink, item.link, item.displayText)
      }
      return null;
    }).filter(value => !!value);
    if (sectionItems.length) {
      nav.push(
          <ExpandableSection
              key={section.sectionTitle}
              header={section.sectionTitle}
              variant="navigation"
              defaultExpanded>
                <TextContent><ul className="expandable-section-content">{sectionItems}</ul></TextContent>
          </ExpandableSection>
      );
    } 
  })
  return <Box className="awsui-side-navigation">{nav}</Box>;
};

function getNavigationItemContent(isExternalLink: boolean, link: string, displayText: string) {
  if (isExternalLink) {
    return (
        <li key={link}>
          <Link href={link} target="_blank">{displayText}</Link>
        </li>
    );
  } else {
    return (
        <li key={link}>
          <NavLink to={link} activeClassName="selected" exact>{displayText}</NavLink>
        </li>
    );
  }
}

export default class NavigationMenu extends Component {

  render() {
    return (
      <Box className='navigation_content'>
        <NavigationContent navItemsArray={navItems} />
        <NavigationContent navItemsArray={lmdpNavItems} />
      </Box>
    );
  }
}
